class MediaViewPreference extends Backbone.Model {
    static options = {
        grid: 'grid',
        list: 'list',
    };

    defaults = {
        view: window.OverDrive.isTolinoDevice
            ? MediaViewPreference.options.list
            : MediaViewPreference.options.grid,
    };

    constructor(params) {
        super(params);

        var initialVal = window.OverDrive.isTolinoDevice
            ? MediaViewPreference.options.list
            : MediaViewPreference.options.grid;

        if (!!Cookies.get('media-view-preference')) {
            initialVal = Cookies.get('media-view-preference');
        } else {
            Cookies.set('media-view-preference', initialVal, {
                httpOnly: false,
                expires: 365,
                sameSite: 'lax',
                secure: true,
            });
        }

        this.set({
            view: initialVal,
        });

        this.listenTo(this, 'change:view', (model, value) => {
            Cookies.set('media-view-preference', value, {
                httpOnly: false,
                expires: 365,
                sameSite: 'lax',
                secure: true,
            });
        });
    }
}

export default MediaViewPreference;
